/**
 * Control Skeleton
 * To extend for creating new custom control
 */

import {CONTROL_FIELD_EXTEND_MIXIN} from "../../mixins/control-field-extend-mixin";

export default {
    name: "BaseControlSkeleton",
    mixins: [CONTROL_FIELD_EXTEND_MIXIN],
}
